/** HTTP client 기본값. 바꿀 때는 `_foundation/fe.md` 의 "HTTP client" 절도 함께 고친다. */
export const API_BASE_URL = '/api';

export const REQUEST_ID_HEADER = 'x-request-id';
export const IDEMPOTENCY_KEY_HEADER = 'idempotency-key';

export const API_TIMEOUT_MS = 15_000;

/** 재시도: GET + (네트워크 오류 · 타임아웃 · 5xx)만. 지수 백오프, 최대 2회 */
export const API_RETRY = {
  maxRetries: 2,
  baseDelayMs: 300,
  factor: 3,
} as const;

/** 부팅(세션 복원) */
export const BOOT = {
  /** `GET /app/status` 로 점검 여부를 먼저 확인할지 */
  checkAppStatus: true,
  /** 서버에 닿지 못했을 때 다시 시도하기 전 기다리는 시간. 길이 = 재시도 횟수 */
  retryBackoffMs: [500, 1500],
} as const;

/**
 * 구 웹 로그인 이어받기(DD-88)를 시도하는 마지막 시각 — 2027-01-31 23:59 KST.
 * 이후 부팅 때의 이어받기 단계는 부르지도 지우지도 않는다(지금과 같은 상태). 새 세션이 생길 때 지우는 것은 그대로. 기한이 지나면 코드와 함께 지운다.
 * 서버 설정(X4 `LEGACY_EXCHANGE_UNTIL`)과 같은 값 — 서버가 먼저 막아도 웹은 거절을 받고 끝난다.
 */
export const LEGACY_EXCHANGE_UNTIL = '2027-01-31T14:59:59Z';
